import { Tag } from './types';

export const initialTag: Tag = {
  id: null,
  name: null,
  version: null,
};
